import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { UserService } from '@services/user.service';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'scaffold-verify-password',
  templateUrl: './verify-password.component.html',
  styleUrls: ['./verify-password.component.scss'],
  standalone: false,
})
export class VerifyPasswordComponent implements OnInit {
  usernameControl = new FormControl({ value: '', disabled: true });
  passwordControl = new FormControl('');
  isWorking: boolean = false;
  errorMessage: string = '';

  constructor(
    private dialogRef: ScaffoldDialogRef,
    private userService: UserService,
    private notifications: NotificationsService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.userService.getRoleDetails().subscribe(roleDetails => {
      this.usernameControl.setValue(roleDetails.cognito_username);
    });
  }

  verifyPassword() {
    if (this.isWorking) return;

    this.isWorking = true;
    this.errorMessage = '';

    const username = this.usernameControl.value;
    const password = this.passwordControl.value;

    this.userService.login(username, password).subscribe({
      next: result => {
        this.isWorking = false;
        if (
          result?.status === 'logged in' ||
          result?.access ||
          result?.ChallengeName
        ) {
          this.dialogRef.close({ username, password });
        } else if (result?.challengeName) {
          // MFA or other challenge - password was correct
          this.dialogRef.close({ username, password });
        } else {
          this.errorMessage = this.translationService.getTranslatedContent(
            'invalid_password',
            'Invalid password'
          );
        }
      },
      error: err => {
        this.isWorking = false;
        this.errorMessage = this.translationService.getTranslatedContent(
          'invalid_password',
          'Invalid password'
        );
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
